(function () {
  'use strict';

  if (!document.body.classList.contains('templateProduct')) return;

  function moveProductExtras() {
    var form = document.querySelector('.product-form.product-action');
    if (!form) return;

    var infoCard = document.getElementById('ht-info-card');
    var frequentlyBought = document.querySelector('.cbb-frequently-bought-container');

    if (infoCard && infoCard.parentElement !== form) {
      form.appendChild(infoCard);
    }

    if (frequentlyBought && frequentlyBought.parentElement !== form) {
      if (infoCard && infoCard.parentElement === form) {
        form.insertBefore(frequentlyBought, infoCard);
      } else {
        form.appendChild(frequentlyBought);
      }
    }
  }

  function initialize() {
    moveProductExtras();

    var observer = new MutationObserver(moveProductExtras);
    observer.observe(document.body, { childList: true, subtree: true });

    setTimeout(function () {
      observer.disconnect();
    }, 30000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize);
  } else {
    initialize();
  }
})();
